<template>
    <th class="vTableHeadline" v-bind:style="{ textAlign: align }">
        <slot />
    </th>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';

    defineProps({
        align: {
            type: String as PropType<'left' | 'center' | 'right'>,
            default: 'center',
        },
    });
</script>
